"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getRefinanceInputs = exports.getAffordabilityByIncomeInputs = exports.getAffordabilityInputs = exports.getMortgageMonthlyInputs = exports.toMortgageMonthlyInputs = exports.getIncome = void 0;
exports.getIncome = function (state) { return state.affordability.monthlyIncome; };
exports.toMortgageMonthlyInputs = function (state) {
    var propertyValue = state.propertyValue;
    var interestRate = state.interestRate;
    var downPayment = state.propertyValue - state.loanAmount;
    var adValoremStampDuty = state.nonFirstTime;
    var hasOutstandingMortgage = state.hasOutstandingMortgage;
    var adValoremStampDutyRate = state.adValoremStampDutyRate;
    var buyerStampDuty = !state.nonCorporate;
    var buyerStampDutyRate = state.buyerStampDutyRate;
    var commissionRate = state.commissionRate;
    var lastTransactionInMonth = state.hasTransactedRecently ? state.hasTransactedRecentlyMonth : -1;
    var doubleAdValoremStampDutyRateTable = state.doubleAdValoremStampDutyRateTable;
    var specialStampDutyRateTable = state.specialStampDutyRateTable;
    var tenor = state.tenor;
    var mortgagePlanList = state.mortgageInsuranceSetting;
    var mortgagePlanListWithProperty = state.mortgageInsuranceSettingWithProperty;
    var mortgageLimitTable = state.mortgageLimitTable;
    var isInsuranceMonthlyRepay = state.isInsuranceMonthlyRepay;
    var legalAmount = state.legalAmount;
    var rateTableInputs = state.rateTableInputs;
    return {
        adValoremStampDuty: adValoremStampDuty,
        adValoremStampDutyRate: adValoremStampDutyRate,
        hasOutstandingMortgage: hasOutstandingMortgage,
        buyerStampDuty: buyerStampDuty,
        buyerStampDutyRate: buyerStampDutyRate,
        commissionRate: commissionRate,
        doubleAdValoremStampDutyRateTable: doubleAdValoremStampDutyRateTable,
        downPayment: downPayment,
        interestRate: interestRate,
        lastTransactionInMonth: lastTransactionInMonth,
        propertyValue: propertyValue,
        specialStampDutyRateTable: specialStampDutyRateTable,
        tenor: tenor,
        mortgagePlanList: mortgagePlanList,
        mortgagePlanListWithProperty: mortgagePlanListWithProperty,
        mortgageLimitTable: mortgageLimitTable,
        isInsuranceMonthlyRepay: isInsuranceMonthlyRepay,
        legalAmount: legalAmount,
        rateTableInputs: rateTableInputs,
    };
};
exports.getMortgageMonthlyInputs = function (state) {
    return exports.toMortgageMonthlyInputs(state.mortgageMonthly);
};
exports.getAffordabilityInputs = function (state) {
    var adValoremStampDuty = state.affordability.nonFirstTime;
    var hasOutstandingMortgage = state.affordability.hasOutstandingMortgage;
    var adValoremStampDutyRate = state.affordability.adValoremStampDutyRate;
    var buyerStampDuty = !state.affordability.nonCorporate;
    var buyerStampDutyRate = state.affordability.buyerStampDutyRate;
    var doubleAdValoremStampDutyRateTable = state.affordability.doubleAdValoremStampDutyRateTable;
    var commissionRate = state.affordability.commissionRate;
    var interestRate = state.affordability.interestRate;
    var lastTransactionInMonth = state.affordability.hasTransactedRecently ? state.affordability.hasTransactedRecentlyMonth : -1;
    var specialStampDutyRateTable = state.affordability.specialStampDutyRateTable;
    var tenor = state.affordability.tenor;
    var monthlyPayment = state.affordability.monthlyPayment;
    var downPayment = state.affordability.downPayment;
    var mortgagePlanList = state.affordability.mortgageInsuranceSetting;
    var mortgagePlanListWithProperty = state.affordability.mortgageInsuranceSettingWithProperty;
    var mortgageLimitTable = state.affordability.mortgageLimitTable;
    var isInsuranceMonthlyRepay = state.affordability.isInsuranceMonthlyRepay;
    var legalAmount = state.affordability.legalAmount;
    var rateTableInputs = state.affordability.rateTableInputs;
    var common = {
        tenor: tenor,
        downPayment: downPayment,
        buyerStampDuty: buyerStampDuty,
        adValoremStampDuty: adValoremStampDuty,
        lastTransactionInMonth: lastTransactionInMonth,
        commissionRate: commissionRate,
        buyerStampDutyRate: buyerStampDutyRate,
        adValoremStampDutyRate: adValoremStampDutyRate,
        specialStampDutyRateTable: specialStampDutyRateTable,
        doubleAdValoremStampDutyRateTable: doubleAdValoremStampDutyRateTable,
        mortgagePlanList: mortgagePlanList,
        mortgagePlanListWithProperty: mortgagePlanListWithProperty,
        mortgageLimitTable: mortgageLimitTable,
        isInsuranceMonthlyRepay: isInsuranceMonthlyRepay,
        legalAmount: legalAmount,
        rateTableInputs: rateTableInputs,
        hasOutstandingMortgage: hasOutstandingMortgage
    };
    return __assign(__assign({}, common), { monthlyPayment: monthlyPayment,
        interestRate: interestRate });
};
exports.getAffordabilityByIncomeInputs = function (state) {
    var output = exports.getAffordabilityInputs(state);
    var monthlyIncome = state.affordability.monthlyIncome;
    var stressTestRateIncrease = state.affordability.stressTestRateIncrease;
    return __assign(__assign({}, output), { interestRate: output.interestRate, monthlyIncome: monthlyIncome, monthlyPayment: 0, debtServiceRatio: 0.5, stressTestIncreasePercent: stressTestRateIncrease });
};
exports.getRefinanceInputs = function (state) {
    var _a = state.refinance, outstandingMortgage = _a.outstandingMortgage, currentTenor = _a.currentTenor, existingInterestRate = _a.existingInterestRate, newPropertyValue = _a.newPropertyValue, newLoan = _a.newLoan, newTenor = _a.newTenor, newInterestRate = _a.newInterestRate;
    var doubleAdValoremStampDutyRateTable = state.refinance.doubleAdValoremStampDutyRateTable;
    var specialStampDutyRateTable = state.refinance.specialStampDutyRateTable;
    return {
        outstandingMortgage: outstandingMortgage,
        currentTenor: currentTenor,
        existingInterestRate: existingInterestRate,
        newPropertyValue: newPropertyValue,
        newLoan: newLoan,
        newTenor: newTenor,
        newInterestRate: newInterestRate,
        doubleAdValoremStampDutyRateTable: doubleAdValoremStampDutyRateTable,
        specialStampDutyRateTable: specialStampDutyRateTable
    };
};
